import { render, staticRenderFns } from "./CompanyTab.vue?vue&type=template&id=e66135ec"
import script from "./CompanyTab.vue?vue&type=script&lang=js"
export * from "./CompanyTab.vue?vue&type=script&lang=js"
import style0 from "./CompanyTab.vue?vue&type=style&index=0&id=e66135ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports